import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {PersonalService} from '../../personal/personal.service';
import {HrService} from '../hr.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, NgForm} from '@angular/forms';
import {PublicHoliday} from '../../admin/models/publicHoliday.model';
import {FabMessageService} from '@fabric/components/message';
import {AuthenticationService} from '../../core/authentication/authentication.service';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'app-new-public-holiday',
    templateUrl: './new-public-holiday.component.html',
    styleUrls: ['./new-public-holiday.component.scss']
})
export class NewPublicHolidayComponent implements OnInit {

    public publicHoliday = {} as PublicHoliday;
    public date = new FormControl(new Date());
    public isBool = false;
    public isPageLoading = false;

    @ViewChild('form') private readonly form!: NgForm;

    constructor(
        private readonly personalService: PersonalService,
        private readonly hrService: HrService,
        private readonly fabMessageService: FabMessageService,
        private readonly authService: AuthenticationService,
        public dialogRef: MatDialogRef<[]>,
        @Inject(MAT_DIALOG_DATA) public selectedData: any) {

    }

    ngOnInit(): void {
        this.publicHoliday.country = this.selectedData;
        this.publicHoliday.updatedBy = this.authService.userInfo.gmin || ''
        this.publicHoliday.halfDay = false;
        this.publicHoliday.shutdownDay = false;
    }

    /**
     * Closes the popup
     */
    close(): void {
        this.dialogRef.close();
    }

    /**
     * Sets the employee dateStarted from the formControl object
     */
    public setModelDate() {
        this.publicHoliday.holidayDate = this.date.value!.toString();
        this.publicHoliday.holidayDate = this.personalService.convertDateFormatForAPI(this.publicHoliday.holidayDate);
    }

    /**
     * Submits a new holiday to the backend through the hr service
     */
    public submitHoliday(bool: boolean): void {
        this.publicHoliday.fixed = bool;
        this.setModelDate();
        this.isPageLoading = true;
        this.hrService.submitPublicHoliday(this.publicHoliday).subscribe({
            next: () => {
                this.fabMessageService.displayMessage('Request submitted successfully');
                this.isPageLoading = false;
                this.close();
            }, error: (err: HttpErrorResponse) => {
                this.fabMessageService.displayErrorMessage(err.error.errorMessage);
                this.isPageLoading = false;
            }
        });
    }
}
